import { defineMessages } from '@/i18n';

export default defineMessages({
  emptyStateTitleSeller: 'platform.app.gallery.artworks.emptyStateTitleSeller',
  emptyStateText: 'platform.app.gallery.artworks.emptyStateText',
  emptyStateCta: 'platform.app.gallery.artworks.emptyStateCta',
  listingArtist: 'platform.app.gallery.artworks.listingArtist',
  listingTitle: 'platform.app.gallery.artworks.listingTitle',
  listingPrice: 'platform.app.gallery.artworks.listingPrice',
  publishedIn: 'platform.app.gallery.artworks.publishedIn',
  publishedInArtBasel: 'platform.app.gallery.artworks.publishedInArtBasel',
  addArtwork: 'platform.app.gallery.artworks.addArtwork',
  bulkUploadCurrencyError: 'platform.app.gallery.bulkUpload.currencyError',
  bulkUploadInstructions: 'platform.app.gallery.bulkUpload.instructions',
  bulkUploadLabel: 'platform.app.gallery.bulkUpload.label',
  bulkUploadFileLabel: 'platform.app.gallery.bulkUpload.fileLabel',
  bulkUploadFileError: 'platform.app.gallery.bulkUpload.fileError',
  bulkUploadEmptyNoteTitle: 'platform.app.gallery.bulkUpload.emptyNoteTitle',
  bulkUploadEmptyNoteDescription: 'platform.app.gallery.bulkUpload.emptyNoteDescription',
  bulkUploadErrorsNoteTitle: 'platform.app.gallery.bulkUpload.errorsNoteTitle',
  bulkUploadErrorsNoteDescription: 'platform.app.gallery.bulkUpload.errorsNoteDescription',
  bulkUploadErrorsNoteRowError: 'platform.app.gallery.bulkUpload.errorsNoteRowError',
  bulkUploadDuplicatesNoteTitle: 'platform.app.gallery.bulkUpload.duplicatesNoteTitle',
  bulkUploadDuplicatesNoteDescription: 'platform.app.gallery.bulkUpload.duplicatesNoteDescription',
  bulkUploadModalErrorsTitle: 'platform.app.gallery.bulkUpload.modalErrorsTitle',
  bulkUploadModalErrorsDescription: 'platform.app.gallery.bulkUpload.modalErrorsDescription',
  bulkUploadModalTitle: 'platform.app.gallery.bulkUpload.modalTitle',
  bulkUploadModalComplete: 'platform.app.gallery.bulkUpload.modalComplete',
  bulkUploadModalFailed: 'platform.app.gallery.bulkUpload.modalFailed',
  bulkUploadTitle: 'platform.app.gallery.bulkUpload.title',
  bulkUploadReviewTitle: 'platform.app.gallery.bulkUpload.reviewTitle',
  retailPriceFieldDescription: 'platform.app.gallery.artworks.retailPriceFieldDescription',
  createArtworkActionLabel: 'platform.app.gallery.artworks.createArtworkActionLabel',
  editArtworkActionLabel: 'platform.app.gallery.artworks.editArtworkActionLabel',
  artistNameLabel: 'platform.app.gallery.artworks.artistNameLabel',
  artistBirthYearLabel: 'platform.app.gallery.artworks.artistBirthYearLabel',
  artistNationalityLabel: 'platform.app.gallery.artworks.artistNationalityLabel',
  artistBioLabel: 'platform.app.gallery.artworks.artistBioLabel',
  titleLabel: 'platform.app.gallery.artworks.titleLabel',
  yearLabel: 'platform.app.gallery.artworks.yearLabel',
  artworkDetailsLabel: 'platform.app.gallery.artworks.artworkDetailsLabel',
  artworkDimensionsLabel: 'platform.app.gallery.artworks.artworkDimensionsLabel',
  optionalLabel: 'platform.app.gallery.artworks.optionalLabel',
  mediumLabel: 'platform.app.gallery.artworks.mediumLabel',
  typePlaceholder: 'platform.app.gallery.artworks.typePlaceholder',
  categoryLabel: 'platform.app.gallery.artworks.typeLabel',
  unitLabel: 'platform.app.gallery.artworks.unitLabel',
  widthLabel: 'platform.app.gallery.artworks.widthLabel',
  heightLabel: 'platform.app.gallery.artworks.heightLabel',
  depthLabel: 'platform.app.gallery.artworks.depthLabel',
  hoursLabel: 'platform.app.gallery.artworks.hoursLabel',
  minutesLabel: 'platform.app.gallery.artworks.minutesLabel',
  secondsLabel: 'platform.app.gallery.artworks.secondsLabel',
  cubicMetersLabel: 'platform.app.gallery.artworks.cubicMetersLabel',
  cubicFeetLabel: 'platform.app.gallery.artworks.cubicFeetLabel',
  otherLabel: 'platform.app.gallery.artworks.otherLabel',
  otherPlaceholder: 'platform.app.gallery.artworks.otherPlaceholder',
  descriptionLabel: 'platform.app.gallery.artworks.descriptionLabel',
  imageDescriptionPlaceholder: 'platform.app.gallery.artworks.imageDescriptionPlaceholder',
  inventoryIdLabel: 'platform.app.gallery.artworks.inventoryIdLabel',
  inventory: 'platform.app.gallery.artworks.inventory',
  retailPriceLabel: 'platform.app.gallery.artworks.retailPriceLabel',
  retailPricePlaceholder: 'platform.app.gallery.artworks.retailPricePlaceholder',
  retailPriceEmptyInfoTitle: 'platform.app.gallery.artworks.retailPriceEmptyInfoTitle',
  retailPriceEmptyInfo: 'platform.app.gallery.artworks.retailPriceEmptyInfo',
  retailPriceCompleteVerificationTitle: 'platform.app.gallery.artworks.retailPriceCompleteVerificationTitle',
  retailPriceCompleteVerificationMessage: 'platform.app.gallery.artworks.retailPriceCompleteVerificationMessage',
  showPurchaseRequestsShortcut: 'platform.app.gallery.artworks.showPurchaseRequests',
  showRequestsShortcut: 'platform.app.gallery.artworks.showRequests',
  imagesTitle: 'platform.app.gallery.artworks.images.title',
  imagesAndVideosTitle: 'platform.app.gallery.artworks.imagesAndVideos.title',
  uploadImagesAndVideos: 'platform.app.gallery.artworks.images.uploadImagesAndVideos',
  dropFileLabelVideosEnabled: 'platform.app.gallery.artworks.imagesAndVideos.dropFile',
  invalidMediaFileSizeError: 'platform.app.gallery.artworks.imagesAndVideos.invalidMediaFileSizeError',
  invalidMediaFileTypeError: 'platform.app.gallery.artworks.imagesAndVideos.invalidMediaFileTypeError',
  dropFileTitle: 'platform.app.gallery.artworks.imagesAndVideos.dropFileTitle',
  addImagesAndVideosLabel: 'platform.app.gallery.artworks.images.addImagesAndVideosLabel',
  uploadMultipleTitle: 'platform.app.gallery.artworks.images.uploadMultipleInviter.title',
  uploadMultipleDescription: 'platform.app.gallery.artworks.images.uploadMultipleInviter.description',
  deleteArtworkTitle: 'platform.app.gallery.artworks.detail.deleteArtwork.title',
  deleteArtworkDescription: 'platform.app.gallery.artworks.detail.deleteArtwork.description',
  deleteArtworkStorefronts: 'platform.app.gallery.artworks.detail.deleteArtwork.storefronts',
  deleteArtworkRequests: 'platform.app.gallery.artworks.detail.deleteArtwork.requests',
  deleteArtworkPurchaseRequests: 'platform.app.gallery.artworks.detail.deleteArtwork.purchaseRequests',
  deleteArtworkPayments: 'platform.app.gallery.artworks.detail.deleteArtwork.payments',
  deleteArtworkDeleteBtn: 'platform.app.gallery.artworks.detail.deleteArtwork.deleteBtn',
  deleteArtworkCancelBtn: 'platform.app.gallery.artworks.detail.deleteArtwork.cancelBtn',
  selectArtworkTitle: 'platform.app.gallery.artworks.detail.selectArtwork.title',
  priceOnRequest: 'platform.app.gallery.artworks.priceOnRequest',
  blockchainLabel: 'platform.app.gallery.artworks.blockchainLabel',
  blockchainAddressDescription: 'platform.app.gallery.artworks.blockchainAddressDescription',
  itemDetailsTitle: 'platform.app.gallery.artworks.itemDetails.title',
  itemDetailsDescription: 'platform.app.gallery.artworks.itemDetails.description',
  itemDetailsCopyLabel: 'platform.app.gallery.artworks.itemDetails.copyLabel',
  itemDetailsCopyArtistLabel: 'platform.app.gallery.artworks.itemDetails.copyArtistLabel',
  itemDetailsCopyAllLabel: 'platform.app.gallery.artworks.itemDetails.copyAllLabel',
  itemDetailsCopyPickerCta: 'platform.app.gallery.artworks.itemDetails.copyPickerCta',
  itemDetailsCopyPickerEmptyState: 'platform.app.gallery.artworks.itemDetails.copyPickerEmptyState',
  itemDetailsCopyPickerTitle: 'platform.app.gallery.artworks.itemDetails.copyPickerTitle',
  editionLabel: 'platform.app.gallery.artworks.itemDetails.editionLabel',
  firstItemMustBeAnImage: 'platform.app.gallery.artworks.imagesAndVideos.firstItemMustBeAnImage',
});
